import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../../config/AxiosConfig';
import {
  QrisTransactionListResp,
  QrisTransactionDetailResp,
} from 'domain/payload/response/bankamar/QrisTransactionResp';

const QrisTransactionService = () => {
  const getList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null,
  ): Promise<QrisTransactionListResp> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/amar-integration/qris-transaction-status/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          size,
          search,
        },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const getDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<QrisTransactionDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/amar-integration/qris-transaction-status/detail`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { id },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { getList, getDetail };
};

export default QrisTransactionService;